import { Outlet } from 'react-router-dom';
import { AppShell } from '@/components/AppShell';
import { OnboardingDialog } from '@/components/OnboardingDialog';

/**
 * Layout for the authenticated portion of the app.
 *
 * The router-level loader (see src/router.tsx) has already enforced auth by
 * the time this component renders — no need for a Redirect/Navigate inside
 * the component. That keeps the auth gate testable in isolation and avoids
 * the brief "rendered then redirected" flash that an in-component check causes.
 */
export function ProtectedLayout() {
  return (
    <AppShell>
      <Outlet />
      <OnboardingDialog />
    </AppShell>
  );
}
